import { useState, useEffect } from 'react';
import { BrowserRouter as Router, useLocation, useSearchParams } from 'react-router-dom';
//import { useMediaQuery } from 'react-responsive'
import { I18nextProvider } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
//import genericStyles from './GenericComponents/GenericStyles.module.css';
import styles from './App.module.css';
import { CCProvider, useCCContext } from './CC/CCContext';
import './CC/CC';
//import Startup from './Startup';
//import User from './User/User';
import Mobile from './Mobile/Mobile';
import Header from './Header/Header';
//import HeaderMobile from './Header/HeaderMobile';
import Footer from './Footer/Footer';
import SimpleSearchBox from './Search/SimpleSearchBox';
import Filter from './Filter/Filter';
import Facet from './Facet/Facet';
import BasketFacet from './Facet/BasketFacet';
import HierarchicalFacet from './Facet/HierarchicalFacet';
import Navigator from './Navigator/Navigator';
import ViewMode from './Navigator/ViewMode';
import BrowseMode from './Navigator/BrowseMode';
import ResultSet from './Result/ResultSet';
import QuerySummary from './Result/QuerySummary';
import Sort from './Navigator/Sort';
import EmbedCount from './Embed/EmbedCount';
import EmbedFacet from './Embed/EmbedFacet';
import EmbedArticle from './Embed/EmbedArticle';
import DebugCC from './Diagnostics/DebugCC';
import GenericIconButton from './GenericComponents/GenericIconButton';
import AlbumViewer from './AlbumEditor/AlbumViewer';
import AnnotatedImageViewer from './AlbumEditor/AnnotatedImageViewer';
import EditorTrial from './EditorTrial/EditorTrial';


function MainContent() {
  const { t } = useTranslation();
  const { user, cc, viewMode, setViewMode, browseMode, isReady } = useCCContext();
  const ctx = useCCContext();
  const [debugOpen, setDebugOpen] = useState(false);
  const [editorOpen, setEditorOpen] = useState(false);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [introTextEnglish] = useState<string>('');
  const [introTextFrench] = useState<string>('');
  const [imageUrl] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  //embed stuff
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const embedType = params.get('embed');
  const facetValue = params.get('facet');
  const articleId = params.get('articleId');
  const state = params.get('state');
  const queryParams = new URLSearchParams(window.location.search);
  const isTabletOrMobile = window.innerWidth < 1080 || queryParams.get('tablet') === 'true' || queryParams.get('mobile') === 'true';

  const showAlbumExternal = queryParams.get('albumexternal');
  const showAlbumEmbed = queryParams.get('albumembed');

  const removeEmbedParam = () => {
    if (searchParams.has('albumembed')) {
      searchParams.delete('albumembed');
      setSearchParams(searchParams);
    }
  }
  const handleEditorClose = () => {
    setEditorOpen(false);
  };

  const handleDebugClose = () => {
    setDebugOpen(false);
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollToTop && window.scrollY > 1000) {
        setShowScrollToTop(true);
      } else if (showScrollToTop && window.scrollY <= 1000) {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener('scroll', checkScrollTop);

    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScrollToTop]);

  useEffect(() => {
    // attach the event listener to 
    // the document object
    document.addEventListener("contextmenu", (e) => {
      //handleContextMenu
      e.preventDefault()
    });

    // clean up the event listener when 
    // the component unmounts
    return () => {
      document.removeEventListener("contextmenu", (e) => {
        //handleContextMenu
        e.preventDefault()
      });
    }
  }, [])

  if (!isReady) {
    return <div></div>;
  }

  if (embedType === 'count') {
    return <EmbedCount state={state} ccContext={ctx} />;
  }

  if (embedType === 'facet' && facetValue) {
    return <EmbedFacet facetName={facetValue} />
  }

  if (embedType === 'article' && articleId) {
    return <EmbedArticle articleId={articleId} ccContext={ctx} />
  }

  if (showAlbumExternal) {
    return <AlbumViewer initialAlbumId={showAlbumExternal} />
  }

  return (
    <I18nextProvider i18n={i18n}>
      {isTabletOrMobile ? (
        showAlbumEmbed ? (
          <AlbumViewer initialAlbumId={showAlbumEmbed} />
        ) : (
          <Mobile />
        )
      ) : (
        <div className={styles.App}>
          <Header />

          <div className={styles.container}>
            <div className={styles.middlePane}>
              <div className={styles.bottomMiddlePane}>
                <div className={styles.leftColumn}>
                  <div className={styles.filters}>
                    <div className={styles.objetsIcono}>
                      <Filter filterName="filter_objects" />
                    </div>
                  </div>

                  <div className={styles.facets}>
                  <div className={styles.facetContainer}>
                      <div role="search" aria-label={`filtrer par ${t("facet_location")}`} className={`${styles.facetName} ${cc.facets['location'] && cc.facets['location'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_location")}</span>
                        {cc.facets['location'] && cc.facets['location'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='location' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>
                    <div className={styles.facetContainer}>
                      <div role="search" aria-label={`filtrer par ${t("facet_persons")}`} className={`${styles.facetName} ${cc.facets['personnes'] && cc.facets['personnes'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_persons")}</span>
                        {cc.facets['personnes'] && cc.facets['personnes'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <Facet facetName='personnes' contentHeight='160px' sort='alpha' />
                      </div>
                    </div>
                    <div className={styles.facetContainer}>
                      <div role="search" aria-label={`filtrer par ${t("facet_medium")}`} className={`${styles.facetName} ${cc.hierarchicalFacets['medium'] && cc.hierarchicalFacets['medium'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_medium")}</span>
                        {cc.hierarchicalFacets['medium'] && cc.hierarchicalFacets['medium'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <HierarchicalFacet hierarchicalFacetName='medium' topCN='MAM.AAB' contentHeight='160px' sort='alpha' showSelectedAbove={false} />
                      </div>
                    </div>
                    <div className={styles.facetContainer}>
                      <div role="search" aria-label={`filtrer par ${t("facet_themes")}`} className={`${styles.facetName} ${cc.hierarchicalFacets['themes'] && cc.hierarchicalFacets['themes'].length > 0 ? styles.facetNameSelected : ''}`}>
                        <span>{t("facet_themes")}</span>
                        {cc.hierarchicalFacets['themes'] && cc.hierarchicalFacets['themes'].length > 0 ?
                          <span className={styles.facetActiveDot}></span> : null}
                      </div>
                      <div className={styles.facet}>
                        <HierarchicalFacet hierarchicalFacetName='themes' topCN='MAM.AAA' contentHeight='160px' sort='alpha' showSelectedAbove={false} />
                      </div>
                    </div>

                    {user && (  // Only show if user is logged in
                      <div className={styles.facetContainer}>
                        <div className={`${styles.facetName} ${cc.customSearchCriteria.some(c => c.fieldLabel === t('basket_items')) ? styles.facetNameSelected : ''}`}>
                          <span>{t("facet_baskets")}</span>
                          {cc.customSearchCriteria.some(c => c.fieldLabel === t('basket_items')) &&
                            <span className={styles.facetActiveDot}></span>
                          }
                        </div>
                        <div className={styles.facet}>
                          <BasketFacet contentHeight='160px' sort='alpha' />
                        </div>
                      </div>
                    )}

                  </div>
                </div>

                {viewMode !== 'homepage' ? (
                  <div className={styles.homePageButton}>
                    <GenericIconButton
                      icon='light/house.svg'
                      hoverEnabled={true}
                      width='28px'
                      height='28px'
                      onClick={(e: any) => {
                        e.preventDefault();
                        //const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false };
                        //const newStateCc = ccUtils.convertStateToCC(newState);
                        //setCc(newStateCc);
                        setViewMode('homepage');
                      }}
                    />
                  </div>
                ) : (
                  <div className={styles.homePageButton}>
                    <GenericIconButton
                      icon='light/house.svg'
                      hoverEnabled={true}
                      width='28px'
                      height='28px'
                      onClick={(e: any) => {
                        e.preventDefault();
                        //const newState = { "Searches": [{ "identifier": "simpleSearch", "field": "All search fields" }], "matchAllCriteria": false };
                        //const newStateCc = ccUtils.convertStateToCC(newState);
                        //setCc(newStateCc);
                        removeEmbedParam();
                        setViewMode('homepage');
                      }}
                    />
                  </div>
                )
                }
                <div className={styles.rightColumn}>
                  <div className={styles.searchContainer}>
                    <div className={styles.simpleSearchBox}>
                      <SimpleSearchBox Fields="simple" id="simpleSearch" showSearchButton={true} />
                    </div>
                  </div>

                  {viewMode !== 'homepage' ?
                    <div>
                      {viewMode !== "map" &&
                        <div className={styles.displayControl}>
                          <ViewMode />
                          <div className={styles.displayControlSeperator} />
                          <div className={styles.displayControlItem}>
                            <BrowseMode />
                          </div>
                          {browseMode !== 'scroll' &&
                            (<>
                              <div className={styles.displayControlSeperator} />
                              <div className={styles.displayControlItem}>
                                <Navigator />
                              </div>
                            </>
                            )
                          }
                          <Sort />
                        </div>
                      }
                      <QuerySummary />

                      {
                          <>
                            <ResultSet />
                            {browseMode !== 'scroll' && (
                              <div className={styles.navigatorBottom}>
                                <div className={styles.displayControlSeperator} />
                                <div className={styles.displayControlItem}>
                                  <Navigator />
                                </div>
                              </div>
                            )}
                          </>
                      }

                    </div>
                    :
                    <div>
                      <div className={styles.intro}>
                        <div className={styles.introText}>
                          {imageUrl && <AnnotatedImageViewer imageName={imageUrl} annotationSource={""} />}
                          {i18n.language === 'en' ? <div className={styles.introTextText} dangerouslySetInnerHTML={{ __html: introTextEnglish }} /> : i18n.language === 'fr' ? <div className={styles.introTextText} dangerouslySetInnerHTML={{ __html: introTextFrench }} /> : ''}
                        </div>
                        <div className={styles.introHyperlink} onClick={(e) => { setViewMode('list') }}>{t("homepage_click_to_view")}</div>
                      </div>
                      {true && (
                        <div>
                          {showAlbumEmbed && <AlbumViewer initialAlbumId={showAlbumEmbed} />}
                          {!showAlbumEmbed && <AlbumViewer initialAlbumId="d8c55875-b9ba-4995-8fc0-f59400eb7af3" />}
                        </div>
                      )}
                    </div>

                  }
                </div>
              </div>
            </div>
          </div>
          {editorOpen && <EditorTrial onClose={handleEditorClose} />}
          {debugOpen && <DebugCC onClose={handleDebugClose} />}
          {
            showScrollToTop &&
            <div className={styles.scrollToTop} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <GenericIconButton icon='regular/chevron-up.svg' width='24px' height='24px' />
            </div>
          }
          <Footer />
        </div>
      )}
    </I18nextProvider>
  );
}

function App() {
  useEffect(() => {
    //console.log('initialize app');
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${process.env.REACT_APP_USERMANAGEMENT_URL}?action=downloadCustomCss&filename=${encodeURIComponent("inlineStyles.css")}`;
    link.type = 'text/css';
    document.head.appendChild(link);

    const link2 = document.createElement('link');
    link2.rel = 'stylesheet';
    link2.href = `${process.env.REACT_APP_USERMANAGEMENT_URL}?action=downloadCustomCss&filename=${encodeURIComponent("paragraphStyles.css")}`;
    link2.type = 'text/css';
    document.head.appendChild(link2);

    return () => {
      document.head.removeChild(link);
      document.head.removeChild(link2);
    };
  }, []);

  return (
    <Router>
      <CCProvider>
        <MainContent />
      </CCProvider>
    </Router>
  );
}

export default App;
